"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const credits = [
    // Evan
    {
        link: "https://evanmmo.com",
        x: 12,
        y: 44,
        width: 51,
        height: 14
    },
    // Ragchomp
    {
        link: "https://www.youtube.com/channel/UCTljefNUAIUavdRcGFfrQZg",
        x: 14,
        y: 63,
        width: 55,
        height: 14
    },
    // Riazey
    {
        link: "https://twitter.com/Lightwing_Games",
        x: 10,
        y: 108,
        width: 41,
        height: 13
    },
    // Osyris
    {
        link: "https://twitter.com/bampikku",
        x: 12,
        y: 126,
        width: 38,
        height: 15
    }
];
exports.default = credits;
